export default __webpack_public_path__ + "static/media/Vermiculated Token of all Fiends.4887db80.jpg";